import { useMutation, useQueryClient } from "@tanstack/react-query";
import type { UseMutationResult } from "@tanstack/react-query";

import { API_ROUTES } from "../../api/ApiRoutes";
import type {
  CreatedSeasonRecord,
  CreateSeasonRequest,
  CreateSeasonResponse,
} from "../../types/gamePass";
import { getPrivateInstance } from "../_privateInstance";
import { getGamePassConfigQueryOptions } from "./useGetGamePassConfig";
import { unwrapGamePassEntity } from "./responseMappers";

const postCreateSeason = async (
  payload: CreateSeasonRequest,
  operatorId: string,
): Promise<CreatedSeasonRecord> => {
  const response = await getPrivateInstance().post<CreateSeasonResponse>(
    API_ROUTES.CREATE_SEASON,
    {
      ...payload,
      operator_id: operatorId,
    },
  );
  return unwrapGamePassEntity(response.data, "season");
};

export const useCreateSeason = (): UseMutationResult<
  CreatedSeasonRecord,
  Error,
  CreateSeasonRequest
> => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: ["game-pass", "seasons", "create"],
    mutationFn: async (payload) => {
      const config = await queryClient.fetchQuery(getGamePassConfigQueryOptions());
      return postCreateSeason(payload, config.operator_id);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["game-pass", "seasons", "list"] });
    },
  });
};
